/**
 * Create ProfileController
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('ProfileController', [
    '$scope',
    '$window',
    'Profile',
    function ($scope, $window, Profile) {

    // Define default Profile Object
    var defaultModel = {
        brands:[]
    }

    // Init base Profile
    $scope.profile = defaultModel

    // Loading state
    $scope.loading = false

    /**
     * Reset the Entity
     *
     * @return Void
     */
    $scope.reset = function() {
        $scope.profile = defaultModel
    }

    /**
     * Init the Controller by fetching the properties of the user
     *
     * @param  object profileId
     * @return Void
     */
    $scope.init = function(id){
        // Set Loading to true
        $scope.loading = $scope.loading || true;
        // Load the Profile
        Profile.get({id:id}, function(resource){
            // Assign brands
            $scope.profile = resource;
            // Set Loading to false
            $scope.loading = false;
            // Nice loaded message
            $.publish('resource.success', 'Profile Loaded');
        }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        });
    }
}]);
